export enum TipoMensagem {
  ERRO = 1,
  INFORMACAO = 2,
  SUCESSO = 3,
  AVISO = 4
}
